import { StopReelsAct } from "onearm";

import { PaylinePaysAct } from "../acts/PaylinePaysAct.js";

export function makePresentation(ctx, result, options = {}) {
    const actions = [];
    const { quickStop = false } = options;
    const { reels, hud, gameLogic, data, paylinesContainer } = ctx;

    actions.push(new StopReelsAct({
        reelsScene: reels,
        result,
        quickStop,
        data,
    }));

    if (result.pays && result.pays.length > 0) {
        actions.push(new PaylinePaysAct({
            result,
            reelsScene: reels,
            hud,
            gameLogic,
            data,
            paylinesContainer,
        }));
    }

    return actions;
}
